import { Link } from '../../components';
import { useAuth } from '../../shared';

export const getOutreachUrl = () => {
  return window.location.origin.replace('admin', 'outreach');
};

export const Products: React.FC = () => {
  const { isSuper, permissions } = useAuth();
  const hasOutreach = isSuper || permissions.some(p => p.includes('outreach'));

  return (
    !!hasOutreach && (
      <div className="py-xs px-md text-small">
        <Link withDecoration withIcon external url={getOutreachUrl()}>
          Go to Outreach
        </Link>
      </div>
    )
  );
};
